<app-form-page
  [content]="content"
  [input]="input"
  [action]="action"
/>

<ng-template #content>
  <div class="m-t-2 m-b-3 text-align-center">
    <svg-icon
      role="img"
      src="assets/images/aptem-assess-logo-content.svg"
      data-ua-id="landing-page-logo"
    >
    </svg-icon>
  </div>

  <h2 class="text-bold text-align-center">
    <app-content
      [key]="pageHeadingKey"
      [value]="pageHeadingValue$ | async"
      [trackingId]="pageHeadingKey"
    >
      <span defaultContent> Register for Aptem Assess</span>
    </app-content>
  </h2>

  <div class="content-layout-column mt-4 mb-4">
    <app-content
      [key]="pageBodyKey"
      [value]="pageBodyValue$ | async"
      [trackingId]="pageBodyKey"
    >
      <div defaultContent>
        <p>Congratulations on starting your new learning programme.</p>

        <p>
          We are committed to ensuring the success of all students, some of whom will have learning support needs.
          Should a potential learning need be identified, tutors can provide extra help.
        </p>

        <p>
          As part of your onboarding, you are asked to complete the Aptem Assess cognitive assessment. This is an
          important, and mandatory, step in your learning journey.
        </p>

        <p>Please complete the form below and we will email you a link to complete the assessment.</p>
      </div>
    </app-content>
  </div>
</ng-template>

<form
  [formGroup]="landingForm"
  (ngSubmit)="onSubmit()"
>
  <ng-template #input>
    @if (showExternalIdField$ | async) {
      <div class="text-text-main m-b-3">
        @if (externalIdLabelValue$ | async) {
          <app-text-input
            trackingId="external-id-input-landing"
            [config]="{
              label: (externalIdLabelValue$ | async),
              controlName: 'externalId',
              elementId: '1',
              validationMessage: (externalIdValidationMessageValue$ | async),
            }"
          >
          </app-text-input>
        }
        @if (!(externalIdLabelValue$ | async)) {
          <app-text-input
            trackingId="external-id-input-landing"
            [config]="{
              label: 'External ID',
              controlName: 'externalId',
              elementId: '1',
              validationMessage: (externalIdValidationMessageValue$ | async),
            }"
          >
          </app-text-input>
        }
      </div>
    }
    <div class="text-text-main m-b-3">
      <app-text-input
        trackingId="full-name-input-landing"
        [config]="{ label: 'Full name', controlName: 'fullName', elementId: '2' }"
      >
      </app-text-input>
    </div>
    <div class="text-text-main m-b-3">
      <app-text-input
        trackingId="email-input-landing"
        [config]="{ label: 'Email address', controlName: 'emailAddress', elementId: '3' }"
      >
      </app-text-input>
    </div>
  </ng-template>

  <ng-template #action>
    <div class="action-button-block-sm-center-md">
      <app-button
        [config]="{ type: 'submit', disabled: landingForm.invalid }"
        trackingId="assessment-landing"
        (clicked)="onSubmit()"
      >
        Send invite
      </app-button>
    </div>
  </ng-template>
</form>
